// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <!-- <v-dialog max-width='600' v-model="$store.state.showPlanetsVisibilityDialog"> -->
  <!-- <div v-if="$store.state.showPlanetsVisibilityDialog" class="pv-container" @click.stop="() => $store.commit('setShowPlanetsVisibilityDialog', false)"> -->
       <div  class="pv-container" @click.stop="() => $store.commit('setShowPlanetsVisibilityDialog', false)"
       :style="`z-index: ${showPlanetsVisibilityDialog ? 1 : -1}`">
    <div class="pv-body">
      <div class="pv-title">{{$t('Solar System')}}</div>
      <div class="pv-row">
        <div class="pv-ab-con">
          <div :class="index%2 == 0 ? 'pv-ab-item' : 'pv-ab-item pv-ab-item-odd'" v-for="(obj, index) in objs"
               :key="cleanName(obj)"></div>
        </div>
        <div class="pv-left">
          <div class="pv-c-item" v-for="obj in objs" :key="cleanName(obj)">
            <img class="pv-c-item-image" :src="require('@/assets/solar/'+ cleanName(obj) +'.png')">
            <div class="pv-c-item-text">{{$t(cleanName(obj))}}</div>
          </div>
        </div>
        <div class="pv-right">
          <div class="pv-ab-con">
            <div class="pv-ab-item" v-for="obj in objs" :key="cleanName(obj)">
              <div style="margin-bottom: 8px" v-html="planetBackgroundStr(obj)"></div>
            </div>
          </div>
          <div class="pv-cont">
            <div class="pv-cont-t">
              <div class="pv-cont-t-item-left">12</div>
              <div class="pv-cont-t-item">18</div>
              <div class="pv-cont-t-item-center">0</div>
              <div class="pv-cont-t-item">6</div>
              <div class="pv-cont-t-item-right">12</div>
            </div>
            <div class="pv-cont-b">
              <div class="pv-con-item pv-con-item-top-left-radius pv-blue"/>
              <div class="pv-con-item pv-blue"/>
              <div class="pv-con-item pv-light-blue6"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-light-blue6"/>
              <div class="pv-con-item pv-blue"/>
              <div class="pv-con-item pv-con-item-top-right-radius pv-blue"/>
            </div>
          </div>
          <div class="pv-con">
            <div class="pv-con-item pv-light-blue3"/>
            <div class="pv-con-item pv-light-blue3"/>
            <div class="pv-con-item pv-light-blue1"/>
            <div class="pv-con-item"/>
            <div class="pv-con-item"/>
            <div class="pv-con-item"/>
            <div class="pv-con-item"/>
            <div class="pv-con-item"/>
            <div class="pv-con-item"/>
            <div class="pv-con-item pv-light-blue1"/>
            <div class="pv-con-item pv-light-blue3"/>
            <div class="pv-con-item pv-light-blue3"/>
          </div>
          <div class="pv-cont" style="height: auto;">
            <div class="pv-cont-b">
              <div class="pv-con-item pv-con-item-bottom-left-radius pv-blue"/>
              <div class="pv-con-item pv-blue"/>
              <div class="pv-con-item pv-light-blue6"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-black-blue"/>
              <div class="pv-con-item pv-light-blue6"/>
              <div class="pv-con-item pv-blue"/>
              <div class="pv-con-item pv-con-item-bottom-right-radius pv-blue"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- </v-dialog> -->
</template>

<script>

  import Moment from 'moment'
  import swh from '@/assets/sw_helpers.js'

  export default {
    data: function () {
      return {
        objs: [
          this.$stel.getObj('NAME Moon'),
          this.$stel.getObj('NAME Mercury'),
          this.$stel.getObj('NAME Venus'),
          this.$stel.getObj('NAME Mars'),
          this.$stel.getObj('NAME Jupiter'),
          this.$stel.getObj('NAME Saturn'),
          this.$stel.getObj('NAME Uranus'),
          this.$stel.getObj('NAME Neptune')
        ],
        colors: {
          "Moon": "#FFFFFA",
          "Mercury": "#B8BECC",
          "Venus": "#F5F4E6",
          "Mars": "#F0A590",
          "Jupiter": "#DBBDBF",
          "Saturn": "#F5DCB0",
          "Uranus": "#6EBCDB",
          "Neptune": "#4668B8"
        }
      }
    },
    methods: {
      formatTime: function (jdm) {
        const d = new Date()
        d.setMJD(jdm)
        const utc = Moment.utc(d)
        utc.local()
        return utc.format('HH:mm')
      },
      cleanName: function (obj) {
        return swh.cleanupOneSkySourceName(obj.designations()[0])
      },
      planetBackgroundStr: function (obj) {
        const d = new Date()
        d.setMJD(obj.computeVisibility()[0].rise)
        const rise = Moment.utc(d)
        rise.local()
        d.setMJD(obj.computeVisibility()[0].set)
        const set = Moment.utc(d)
        set.local()

        var hourToPercent = function (h) {
          return (h >= 12) ? Math.round((h - 12) / 24 * 100) : Math.round((h + 12) / 24 * 100)
        }


        const riseP = hourToPercent(rise.hours())
        const setP = hourToPercent(set.hours())
        const height = 8;
        if (setP > riseP) {
          let ret = `<div style='z-index: 100; position: absolute; background-color: ${this.colors[this.cleanName(obj)]}; left: ${riseP}%; min-width: ${(setP - riseP)}%;  height: ${height}px; border-bottom-left-radius: ${height / 2}px; border-top-left-radius: ${height / 2}px; border-bottom-right-radius: ${height / 2}px; border-top-right-radius: ${height / 2}px;'></div>`;
          ret += `<div style="z-index: 100; position: absolute; left: ${riseP}%; min-width: ${(setP - riseP)}%; margin-top: ${height / 6 * 5}px; display: flex; flex-direction: row; justify-content: space-between">
                <div style="display: flex; font-size: 12px; transform: scale(0.8); white-space: nowrap;">${Moment(rise).format('HH:mm')}</div>
                <div style="display: flex; font-size: 12px; transform: scale(0.8); white-space: nowrap;">${Moment(set).format('HH:mm')}</div>
          </div>`;
          return ret
        } else {
          let ret = `<div style='z-index: 100; position: absolute; background-color: ${this.colors[this.cleanName(obj)]}; left: 0%; min-width: ${setP}%;  height: ${height}px; border-bottom-right-radius: ${height / 2}px; border-top-right-radius: ${height / 2}px;'></div>`
          if (setP) {
            ret += `<div style="z-index: 100; position: absolute; left: 0%; min-width: ${setP}%; margin-top: ${height / 6 * 5}px; display: flex; flex-direction: row; justify-content: space-between">
                <div style="display: flex; font-size: 12px; transform: scale(0.8); white-space: nowrap;"></div>
                <div style="display: flex; font-size: 12px; transform: scale(0.8); white-space: nowrap;">${Moment(set).format('HH:mm')}</div>
          </div>`;
          }
          ret += `<div style='z-index: 100; position: absolute; background-color: ${this.colors[this.cleanName(obj)]}; right: 0%; min-width: ${100 - riseP}%;  height: ${height}px; border-bottom-left-radius: ${height / 2}px; border-top-left-radius: ${height / 2}px;'></div>`
          if (riseP) {
            ret += `<div style="z-index: 100; position: absolute; right: 0%; min-width: ${100 - riseP}%; margin-top: ${height / 6 * 5}px; display: flex; flex-direction: row; justify-content: space-between">
                <div style="display: flex; font-size: 12px; transform: scale(0.8); white-space: nowrap;">${Moment(rise).format('HH:mm')}</div>
                <div style="display: flex; font-size: 12px; transform: scale(0.8); white-space: nowrap;"></div>
          </div>`;
          }
          return ret
        }
      }
    },
    computed: {
      showPlanetsVisibilityDialog() {
        return this.$store.state.showPlanetsVisibilityDialog || false;
      },
      sunBackgroundStr: function () {
        var sun = this.$stel.getObj('NAME Sun')
        const brightness = []
        const d = new Moment(this.startDate)

        const obs = this.$stel.core.observer.clone()
        for (let i = 0; i < 25; i++) {
          obs.utc = d.toDate().getMJD()
          d.local()
          const azalt = this.$stel.convertFrame(obs, 'ICRF', 'OBSERVED', sun.getInfo('radec', obs))
          const alt = this.$stel.anpm(this.$stel.c2s(azalt)[1]) * 180.0 / Math.PI
          brightness.push(alt / (Math.PI / 2))
          d.add(1, 'hours')
        }
        obs.destroy()

        var txt = 'position: relative; background: linear-gradient(to right, '
        for (let i = 0; i < 25; i++) {
          let bi = (brightness[i] + 0.1) * 5
          bi = bi > 1 ? 1 : bi
          bi = bi < 0 ? 0 : bi
          txt += 'rgb(' + Math.round(53 * bi) + ', ' + Math.round(173 * bi) + ', ' + Math.round(211 * bi) + ') ' + Math.round(i / 24 * 100) + '% '
          if (i !== 24) {
            txt += ','
          }
        }
        txt += '); min-width: 100%; height: 100%'
        return txt
      },
      startDate: function () {
        var sun = this.$stel.getObj('NAME Sun')
        let u = this.$store.state.stel.observer.utc
        if (u < sun.rise) {
          // It's still night (in the morning), display last night's planets visibility
          u = u - 1
        }
        let d = new Date()
        d.setMJD(u)
        d = new Moment(d)
        d.local()
        d.hours(12)
        d.minutes(0)
        d.seconds(0)
        return d
      },
      endDate: function () {
        const d = new Moment(this.startDate)
        d.add(1, 'd')
        return d
      }
    }
  }
</script>

<style lang="scss">
  $pv-planets-cnt: 8 !default;

  .pv-container {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: auto;
    z-index: -1;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .pv-title {
    display: flex;
    margin-left: 15px;
    font-size: 16px;
  }

  .pv-row {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .pv-ab-con {
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 30px;
    left: 0;
    right: 0;
  }

  .pv-ab-item {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
  }

  .pv-ab-item-odd {
    background: rgba(38, 38, 72, 0.36);
  }


  .pv-left {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    padding-top: 30px;
  }

  .pv-c-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 50px;
  }

  .pv-c-item-image {
    width: 15px;
    height: 15px;
    margin-left: 25px;
  }

  .pv-c-item-text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    margin-left: 15px;
  }

  .pv-right {
    position: relative;
    display: flex;
    width: 60%;
    flex-direction: column;
    margin-right: 15px;
  }


  .pv-cont {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 30px;
  }

  .pv-cont-t {
    position: relative;
    display: flex;
    flex-direction: row;
  }

  .pv-cont-t-item {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: center;
    font-size: 13px;
  }

  .pv-cont-t-item-left {
    position: absolute;
    display: flex;
    left: -7px;
    flex: 1;
    flex-direction: row;
    justify-content: center;
    font-size: 14px;
  }

  .pv-cont-t-item-right {
    position: absolute;
    display: flex;
    right: -7px;
    flex: 1;
    flex-direction: row;
    justify-content: center;
    font-size: 14px;
  }

  .pv-cont-t-item-center {
    position: absolute;
    display: flex;
    left: 0;
    right: 0;
    flex: 1;
    flex-direction: row;
    justify-content: center;
    font-size: 14px;
  }

  .pv-cont-b {
    display: flex;
    flex-direction: row;
    height: 12px;
  }

  .pv-con {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 50px * $pv-planets-cnt;
  }

  .pv-con-item {
    display: flex;
    flex: 1;
    border-left: 1px dotted rgba(255, 255, 255, 0.1);
  }

  .pv-con-item-top-left-radius {
    border-top-left-radius: 8px;
  }

  .pv-con-item-top-right-radius {
    border-top-right-radius: 8px;
  }

  .pv-con-item-bottom-left-radius {
    border-bottom-left-radius: 8px;
  }

  .pv-con-item-bottom-right-radius {
    border-bottom-right-radius: 8px;
  }


  .pv-con-item:nth-child(1) {
    border-left: 1px dotted rgba(255, 255, 255, 0);
  }

  .pv-con-item:nth-child(7) {
    border-left: 1px dotted rgba(255, 255, 255, 0.36);
  }


  .pv-blue {
    background: rgba(127, 178, 255, 1);
  }

  .pv-light-blue6 {
    background: rgba(127, 178, 255, 0.6);
  }

  .pv-light-blue3 {
    background: rgba(127, 178, 255, 0.3);
  }

  .pv-light-blue1 {
    background: rgba(127, 178, 255, 0.1);
  }

  .pv-black-blue {
    background: #1D1D36;
  }

  @media screen and (min-width: 500px) {
    .pv-body {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 400px;
      background: #323256;
      border-radius: 8px;
      padding: 20px 0;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  @media screen and (max-width: 500px) {
    .pv-body {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 80%;
      background: #323256;
      border-radius: 5px;
      padding: 15px 0;
      color: rgba(255, 255, 255, 0.8);
    }

    .pv-title {
      display: flex;
      margin-left: 10px;
      font-size: 14px;
    }

    .pv-row {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .pv-ab-con {
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 20px;
      left: 0;
      right: 0;
    }

    .pv-ab-item {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 35px;
    }

    .pv-ab-item-odd {
      background: rgba(38, 38, 72, 0.36);
    }


    .pv-left {
      position: relative;
      display: flex;
      flex: 1;
      flex-direction: column;
      padding-top: 20px;
    }

    .pv-c-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 35px;
    }

    .pv-c-item-image {
      width: 15px;
      height: 15px;
      margin-left: 20px;
    }

    .pv-c-item-text {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
      margin-left: 10px;
    }

    .pv-right {
      position: relative;
      display: flex;
      width: 60%;
      flex-direction: column;
      margin-right: 15px;
    }


    .pv-cont {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: 20px;
    }

    .pv-cont-t {
      position: relative;
      display: flex;
      flex-direction: row;
    }

    .pv-cont-t-item {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: center;
      font-size: 12px;
      transform: scale(0.9);
    }

    .pv-cont-t-item-left {
      position: absolute;
      display: flex;
      left: -5px;
      flex: 1;
      flex-direction: row;
      justify-content: center;
      font-size: 12px;
      transform: scale(0.9);
    }

    .pv-cont-t-item-right {
      position: absolute;
      display: flex;
      right: -5px;
      flex: 1;
      flex-direction: row;
      justify-content: center;
      font-size: 12px;
      transform: scale(0.9);
    }

    .pv-cont-t-item-center {
      position: absolute;
      display: flex;
      left: 0;
      right: 0;
      flex: 1;
      flex-direction: row;
      justify-content: center;
      font-size: 12px;
      transform: scale(0.9);
    }

    .pv-cont-b {
      display: flex;
      flex-direction: row;
      height: 10px;
    }

    .pv-con {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 35px * $pv-planets-cnt;
    }

    .pv-con-item {
      display: flex;
      flex: 1;
      border-left: 1px dotted rgba(255, 255, 255, 0.1);
    }

    .pv-con-item-top-left-radius {
      border-top-left-radius: 5px;
    }

    .pv-con-item-top-right-radius {
      border-top-right-radius: 5px;
    }

    .pv-con-item-bottom-left-radius {
      border-bottom-left-radius: 5px;
    }

    .pv-con-item-bottom-right-radius {
      border-bottom-right-radius: 5px;
    }
  }
</style>
